import { PaperBackground } from './PaperBackground';

export default PaperBackground;
